import React from "react";
import { PencilSimple } from "@phosphor-icons/react";

export const ReconcileCorrectionNote = ({ activity }) => {
  if (!activity || activity.status !== "completed") return null;
  const frozen = ["invoiced", "paid"].includes(activity.billing_status);
  const last = (activity.trips_corrections || []).slice(-1)[0];
  return (
    <div className="bg-sky-50 border border-sky-200 rounded p-2.5 text-[11px] text-ps-deep space-y-0.5" data-testid="reconcile-correction-note">
      <div className="flex items-center gap-1.5 font-semibold">
        <PencilSimple size={12} weight="bold" className="text-ps-blue" />
        Already reconciled at <span className="font-mono-data" data-testid="reconcile-previous-trips">{activity.trips_done ?? 0}</span> trip{activity.trips_done === 1 ? "" : "s"} — saving will correct it.
      </div>
      {last && (
        <div className="text-slate-500" data-testid="reconcile-last-correction">
          Last corrected {last.from} → {last.to} by {last.by || "—"} on {String(last.at || "").slice(0, 10)}
        </div>
      )}
      {frozen && (
        <div className="text-amber-800" data-testid="reconcile-invoiced-warning">
          This trip is already {activity.billing_status} — the invoice amount will not change.
        </div>
      )}
    </div>
  );
};
